const awsmobile = {
  "aws_user_pools_web_client_id": "62so363jdmth1c5cdb0t72k2mu", //This id is referenced at
};


export default awsmobile;
